import { Component, EventEmitter, forwardRef, Input, OnInit, Output } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { FormGroup } from "@angular/forms";
import { PrimeNG } from "primeng/config";
import { DateHelper } from "../../helpers/date.helper";

@Component({
  standalone: false,
  selector: 'app-calendar',
  templateUrl: './calendar.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CalendarComponent),
      multi: true,
    },
  ],
})

export class CalendarComponent implements OnInit {
  @Input() placeHolder: string;
  @Input() isNgModel: boolean;
  @Input() parentForm: FormGroup;
  @Input() parentControl: string;
  @Input() isDisabled: boolean;

  @Output() readonly dateChanged: EventEmitter<string> = new EventEmitter<string>();

  value: any;
  onChange = (value: any) => {
  };
  onTouched = () => {
  };


  constructor(private primeng: PrimeNG,
              private dateHelper: DateHelper) {
  }

  ngOnInit(): void {
    this.primeng.setTranslation(this.dateHelper.calendarOptions);
  }

  onDateChange(event: any): void {
    if (event) {
      event.setHours(12, 0, 0, 0); // fixed time to avoid the problem with time zones and going back 1 day
    }

    this.value = event; // Update the value
    this.onChange(event); // Notify Angular about the change
    this.dateChanged.emit(event); // Emit the custom event
  }

  // ControlValueAccessor methods for ngModel
  writeValue(value: any): void {
    this.value = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
}
